/** Combined All-tab RCM column ids (union of Process + ITGC). */
export const RCM_ALL_TABLE_COLUMNS = [
  { id: 'srNo', label: 'Sr. No.', hideable: false },
  { id: 'classification', label: 'Classification', hideable: true },
  { id: 'soxCycle', label: 'SOX Cycle', hideable: true },
  { id: 'subProcess', label: 'Sub-process', hideable: true },
  { id: 'domain', label: 'Domain', hideable: true },
  { id: 'system', label: 'System', hideable: true },
  { id: 'riskId', label: 'Risk ID', hideable: true },
  { id: 'clientRiskId', label: 'Client Risk ID', hideable: true },
  { id: 'riskDescription', label: 'Risk Description', hideable: true },
  { id: 'controlId', label: 'Control ID', hideable: true },
  { id: 'controlObjective', label: 'Control Objective Description', hideable: true },
  { id: 'controlDescription', label: 'Control Description', hideable: true },
  { id: 'completeness', label: 'Completeness (C)', hideable: true, assertion: true },
  { id: 'existenceOccurrence', label: 'Existence & Occurrence (E&O)', hideable: true, assertion: true },
  { id: 'accuracy', label: 'Accuracy (A)', hideable: true, assertion: true },
  { id: 'valuation', label: 'Valuation (V)', hideable: true, assertion: true },
  { id: 'rightsObligations', label: 'Rights & Obligations (R&O)', hideable: true, assertion: true },
  { id: 'what', label: 'Control Title', hideable: true },
  { id: 'who', label: 'Control Owner', hideable: true },
  { id: 'keyReports', label: 'Key Reports', hideable: true },
  { id: 'when', label: 'Frequency', hideable: true },
  { id: 'controlType', label: 'Control Type', hideable: true },
  { id: 'keyNonKey', label: 'Key / Non Key', hideable: true },
  { id: 'riskCategory', label: 'Risk Category', hideable: true },
];

export function createDefaultRcmAllColumnVisibility() {
  return Object.fromEntries(RCM_ALL_TABLE_COLUMNS.map((column) => [column.id, true]));
}

export function isRcmAllColumnVisible(columnVisibility, columnId) {
  if (!columnId) return false;
  return columnVisibility?.[columnId] !== false;
}

export function getVisibleRcmAllColumnCount(columnVisibility) {
  return RCM_ALL_TABLE_COLUMNS.filter((column) => isRcmAllColumnVisible(columnVisibility, column.id)).length;
}

export function getHideableRcmAllColumns() {
  return RCM_ALL_TABLE_COLUMNS.filter((column) => column.hideable !== false);
}

export function getDefaultRcmAllColumnOrder() {
  return RCM_ALL_TABLE_COLUMNS.map((column) => column.id);
}

export function mergeRcmAllHideableOrder(fullOrder, orderedHideableIds) {
  const base = Array.isArray(fullOrder) && fullOrder.length > 0
    ? [...fullOrder]
    : getDefaultRcmAllColumnOrder();
  const hideableSet = new Set(orderedHideableIds);
  let cursor = 0;
  const next = base.map((id) => {
    if (!hideableSet.has(id)) return id;
    const replacement = orderedHideableIds[cursor];
    cursor += 1;
    return replacement ?? id;
  });
  for (const id of orderedHideableIds) {
    if (!next.includes(id)) next.push(id);
  }
  for (const id of getDefaultRcmAllColumnOrder()) {
    if (!next.includes(id)) next.push(id);
  }
  return next;
}

export function getOrderedVisibleRcmAllColumnIds(columnOrder, columnVisibility) {
  const order = Array.isArray(columnOrder) && columnOrder.length > 0
    ? columnOrder
    : getDefaultRcmAllColumnOrder();
  const known = new Set(RCM_ALL_TABLE_COLUMNS.map((c) => c.id));
  return order.filter((id) => known.has(id) && isRcmAllColumnVisible(columnVisibility, id));
}
